'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reselect = require('reselect');

/**
 * Creates a memoize-less selector. The reason of using this instead of the default
 * `createSelector` for now is that with our current codebase we cannot guarantee
 * that we're using immutable data on each input which ruins object/array equality
 * checks we can do as a comparison.
 *
 * There's still benefits of creating selectors though (i.e. increased readability),
 * and this createSelector can also be tuned for increased performance by using a
 * more efficient memoize cache. See https://github.com/medikoo/memoizee for example
 */
exports.default = (0, _reselect.createSelectorCreator)(function (func) {
  return function () {
    return func.apply(undefined, arguments);
  };
});


//////////////////
// WEBPACK FOOTER
// ./~/dibs-display-helpers/~/dibs-selectors/dist/utils/createSelector.js
// module id = 1236
// module chunks = 63